import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../../Config";
import Loading from "../../../Components/Loading";
import Table from "../../../Components/Properties/Lease/TableForLockin";
import {
  BoxTitle,
  BoxContainer,
  BoxHead,
  Underline,
} from "../../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import moment from "moment";
import NotFoundModel from "../../../Components/NotFoundModel";
import { SummarySkeletonLoading } from "../../../Components/SkeletonLoading";
import SummaryCard from "../../../Components/Properties/Lease/SummaryCardForLockin";

const LockinTracker = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const [isFocused, setIsFocused] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [filter, setFilter] = useState("");
  const [apiData, setApiData] = useState();
  const [masterData, setMasterData] = useState();

  const [summaryData, setSummaryData] = useState({
    totalMovedOut: 0,
    curMonthMovedOut: 0,
    defaulters: 0,
    totalDefaultedDues: 0,
  });

  const query = `propId=${property?.id}&searchVal=&filter=${filter}&platform=3`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/landlord/web/lockin-tracker?${query}`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === true) {
      setApiData(res?.list);
      setSummaryData(res?.stats);
      setMasterData(res?.list);
      setIsFocused(true);
    } else {
      error = true;
    }
  };

  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    isFetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    if (filter && !isFirstTime && !isFetching && !isRefetching && !isLoading) {
      const handler = setTimeout(() => {
        getListMutate();
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [filter]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
      setIsFirstTime(false);
    }, 100);
    return () => {
      clearTimeout(handler);
    };
  }, [property]);

  const onSummaryBoxClick = (data) => {
    sessionStorage.removeItem("landlord_lockin_page");
    let filteredData;
    const currentDate = moment().startOf("day");

    if (data === "ECM") {//Expiring Current Month
      const startOfMonth = currentDate.clone().startOf("month").format("YYYY-MM-DD");
      const endOfMonth = currentDate.clone().endOf("month").format("YYYY-MM-DD");

      filteredData = masterData.filter((leaseData) => {
        if (!leaseData.startDate || leaseData.lockInPeriod === undefined) return false;
        const expiryDate = moment(leaseData.startDate).add(leaseData.lockInPeriod, 'months');
        return expiryDate.isBetween(startOfMonth, endOfMonth, null, "[]");
      });

    } else if (data === "ENM") {//Expiring Next Month
      const startOfNextMonth = currentDate
        .clone()
        .add(1, "months")
        .startOf("month");
      const endOfNextMonth = currentDate
        .clone()
        .add(1, "months")
        .endOf("month");

      filteredData = masterData.filter((leaseData) => {
        if (!leaseData.startDate || leaseData.lockInPeriod === undefined) return false;
        const expiryDate = moment(leaseData.startDate).add(leaseData.lockInPeriod, 'months');
        return expiryDate.isBetween(startOfNextMonth, endOfNextMonth, null, "[]");
      });

    } else if (data === "E") {
      filteredData = masterData.filter((leaseData) => {
        if (!leaseData.startDate || leaseData.lockInPeriod === undefined) return false;
        const expiryDate = moment(leaseData.startDate).add(leaseData.lockInPeriod, 'months');
        return expiryDate.isBefore(currentDate);
      });

    } else {
      filteredData = masterData;
    }
    setApiData(filteredData);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Lockin Tracker
            <Underline />
          </BoxTitle>
        </BoxHead>

        {(isLoading || isRefetching) && !isFocused && (
          <SummarySkeletonLoading count={3} />
        )}
        {isFocused && apiData && (
          <SummaryCard summaryData={summaryData} onClick={onSummaryBoxClick} />
        )}

        {!error && !isLoading && apiData && (
          <TableWrapper>
            <Table
              apiData={error ? [] : apiData?.length > 0 ? apiData : []}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
            />
            {(error || apiData.length === 0) && !isLoading && <NotFoundModel msg={"No Data Found."} />}
          </TableWrapper>
        )}
        {(isLoading || isRefetching) && <Loading />}
        {error && !isLoading && <NotFoundModel />}
      </BoxContainer>
    </>
  );
};

const TableWrapper = tw.h1`my-8 border bg-white rounded-md `;

export default LockinTracker;
